import { IDs } from '../../../helpers/IDs';
import * as React from 'react';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface VerbandszuordnungProps extends React.ClassAttributes<any> {
    data: any;
}

export class Verbandszuordnung extends React.Component<VerbandszuordnungProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    onFormChange(WFormData: any): void {
        const values: any = WFormData.getAllValues() || {};
        const verband: string = ((WFormData.getBundleValues(IDs.ENT_VERBAND) || [])
            .find((item: any) => item.tid === values.verband) || {}).name || '';
        const unternehmen: string = ((WFormData.getBundleValues(IDs.ENT_REGISTRIERUNG) || [])
            .find((item: any) => item.tid === values.registrierung) || {}).unternehmen || '';
        WFormData.setValue(
            'name',
            verband.length && unternehmen.length
                ? [verband, unternehmen].join(', ')
                : `${verband}${unternehmen}`
        );
    }

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_VERBAND_ZUORDNUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                formLayout='flowV2'
                customClass='Custom-ETA'
                onFormChange={this.onFormChange}
                showColumnsHelp={true}
            />
        );
    }
}
